var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tabbar',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('tabbar-item',{attrs:{"icon":"home-o"}},[_vm._v("工作台")]),_c('tabbar-item',{attrs:{"icon":"user-o"}},[_vm._v("我的")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }